import { action } from 'satcheljs';

export interface OnOpenMessageExtensionComposeAppActionMessage {
    appId: string;
}
const onOpenMessageExtensionComposeApp: (
    message: OnOpenMessageExtensionComposeAppActionMessage
) => OnOpenMessageExtensionComposeAppActionMessage = action(
    'onOpenMessageExtensionComposeApp',
    (
        message: OnOpenMessageExtensionComposeAppActionMessage
    ): OnOpenMessageExtensionComposeAppActionMessage => message
);
export default onOpenMessageExtensionComposeApp;
